import React from 'react';
import { Block, PdfBlockContent } from '../types';
import { DownloadRegularIcon, RefreshLightIcon } from 'src/monet/icons';
import { ControlPanelActionButton } from '../components/control-panel/action-button';
import { ToggleBlockCaption } from '../components/toggle-block-caption';
import { ControlPanelSwitchButton } from '../components/control-panel/switch';
import { TogglePersonalContent } from '../components/toggle-personal-content';
import { ToggleVideoDocPersonalContent } from '../components/toggle-video-doc-personal-content';

type Props = {
  block: Block;
  onReplaceBlock: () => void;
  onAllowDownloadChange: (allowDownload: boolean) => void;
};

export const EditPdfControlPanelContent = ({ block, onReplaceBlock, onAllowDownloadChange }: Props) => {
  const blockContent = block.content as PdfBlockContent;

  return (
    <>
      <div className='flex flex-col'>
        <ControlPanelSwitchButton
          checked={blockContent.allowDownload || false}
          onChange={onAllowDownloadChange}
          icon={<DownloadRegularIcon className='shrink-0 w-4 h-4' />}
          label='Allow download'
        />
        <ToggleBlockCaption block={block} />
        <ToggleVideoDocPersonalContent
          block={block}
          contentObject={{
            file_url: blockContent?.jnyContent?.file_asset?.url || '',
            file_content_type: blockContent.file?.type || '',
            name:
              blockContent?.file?.name ||
              blockContent?.metadata?.name ||
              blockContent?.jnyContent?.file_asset?.url ||
              '',
          }}
        />
        <ControlPanelActionButton iconComponent={RefreshLightIcon} label='Replace block' onClick={onReplaceBlock} />
      </div>
    </>
  );
};
